const SearchVehicleInfo = () => {
    return (
        <div className='system-admin-wrapper'>
            <h1>Coming Soon</h1>
        </div>
    );
};

export default SearchVehicleInfo;
